import React from "react";
import { useSelector } from "react-redux";
import HeaderAppBar from "../components/HeaderAppBar";
import HeaderManager from "../components/HeaderManager";
import HeaderUser from "../components/HeaderUser";
import Constants from "../helper/resources/Constants";
import PrivateRoute from "./PrivateRoute";
import DebitAutomatic from "../pages/DebitAutomatic";
import SelectedDebits from "../pages/SelectedDebits";
import DebitAutomaticRegister from "../pages/DebitAutomaticRegister";
import ChangeQuotas from "../pages/ChangeQuotas";
import PaymentBankConfirmation from "../pages/PaymentBankConfirmation";
import PaymentBank from "../pages/PaymentBank";
import PaymentDAM from "../pages/PaymentDAM";
import DebitCardConfirmation from "../pages/DebitCardConfirmation";
import ReportsNonMixedBanks from "../pages/ReportsNonMixedBanks";
import ConsultarDAM from "../pages/FindDAM";
import PaymentCreditCardConfirmation from "../pages/PaymentCreditCardConfirmation";
import PaymentMethods from "../pages/PaymentMethods";
import DebitsManager from "../pages/DebitsManager";
import HiddenDebts from "../pages/HiddenDebts";
import ListBanks from "../pages/ListBanks";
import EditBanks from "../pages/EditBanks";
import FindDAMManager from "../pages/FindDAMManager";
import ListAdquirentes from "../pages/ListAcquirers";
import ButtonAppBar from "../components/Footer";
import TabsDebits from "../pages/TabsDebits";

export default function Routes() {
  const profile = useSelector(({ auth }) => auth.profile);

  return (
    <>
      <HeaderAppBar />
      <PrivateRoute
        exact
        path="/bem-vindo"
        component={() => <div>Bem vindo!!</div>}
      />
      {profile === Constants.PERFIL_CONTRIBUINTE && (
        <>
          <HeaderUser />
          <PrivateRoute exact path="/consultar-dam" component={ConsultarDAM} />
          <PrivateRoute exact path="/" component={TabsDebits} />
          <PrivateRoute
            exact
            path="/debitos-selecionados"
            component={SelectedDebits}
          />
          <PrivateRoute
            exact
            path="/debito-automatico"
            component={DebitAutomatic}
          />
          <PrivateRoute
            exact
            path="/cadastrar-debito-automatico"
            component={DebitAutomaticRegister}
          />
          <PrivateRoute
            exact
            path="/banco-nao-misto"
            component={ReportsNonMixedBanks}
          />
          <PrivateRoute exact path="/alterar-cotas" component={ChangeQuotas} />
          <PrivateRoute
            exact
            path="/pagamento-via-banco"
            component={PaymentBank}
          />
          <PrivateRoute
            exact
            path="/pagamento-via-dam"
            component={PaymentDAM}
          />
          <PrivateRoute
            exact
            path="/confirmacao-pagamento"
            component={PaymentBankConfirmation}
          />
          <PrivateRoute
            exact
            path="/confirmacao-pagamento-credito"
            component={PaymentCreditCardConfirmation}
          />
          <PrivateRoute
            exact
            path="/confirmacao-debito-automatico"
            component={DebitCardConfirmation}
          />
          <PrivateRoute
            exact
            path="/formas-pagamento"
            component={PaymentMethods}
          />
        </>
      )}
      {profile === Constants.PERFIL_GESTOR && (
        <>
          <HeaderManager />
          <PrivateRoute exact path="/" component={DebitsManager} />
          <PrivateRoute
            exact
            path="/debitos-ocultados"
            component={HiddenDebts}
          />
          <PrivateRoute
            exact
            path="/debitos-selecionados"
            component={SelectedDebits}
          />
          <PrivateRoute exact path="/consultar-dam" component={ConsultarDAM} />
          <PrivateRoute
            exact
            path="/debito-automatico"
            component={DebitAutomatic}
          />
          <PrivateRoute
            exact
            path="/cadastrar-debito-automatico"
            component={DebitAutomaticRegister}
          />
          <PrivateRoute
            exact
            path="/banco-nao-misto"
            component={ReportsNonMixedBanks}
          />
          <PrivateRoute exact path="/alterar-cotas" component={ChangeQuotas} />
          <PrivateRoute
            exact
            path="/confirmacao-debito-automatico"
            component={DebitCardConfirmation}
          />
          <PrivateRoute exact path="/bancos" component={ListBanks} />
          <PrivateRoute exact path="/editar-banco" component={EditBanks} />
          <PrivateRoute exact path="/adquirentes" component={ListAdquirentes} />
          <PrivateRoute
            exact
            path="/editar-adquirentes"
            component={EditBanks}
          />
          <PrivateRoute exact path="/dam" component={FindDAMManager} />
        </>
      )}

      {profile === Constants.PERFIL_ATENDENTE && (
        <>
          <HeaderManager />
          <PrivateRoute exact path="/" component={DebitsManager} />
          <PrivateRoute
            exact
            path="/debitos-ocultados"
            component={HiddenDebts}
          />
          <PrivateRoute
            exact
            path="/debitos-selecionados"
            component={SelectedDebits}
          />
          <PrivateRoute exact path="/consultar-dam" component={ConsultarDAM} />
          <PrivateRoute
            exact
            path="/debito-automatico"
            component={DebitAutomatic}
          />
          <PrivateRoute
            exact
            path="/cadastrar-debito-automatico"
            component={DebitAutomaticRegister}
          />
          <PrivateRoute
            exact
            path="/confirmacao-debito-automatico"
            component={DebitCardConfirmation}
          />
          <PrivateRoute exact path="/dam" component={FindDAMManager} />
        </>
      )}
      <ButtonAppBar />
    </>
  );
}
